import { Component, OnInit } from '@angular/core';
import { ModalAddTractionCarComponent } from '../../modal-add-traction-car/modal-add-traction-car.component';
import { MatButton, MatDialog } from '@angular/material';
import { UserService } from '@accounts/user/services/user.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'user-traction-cars',
  templateUrl: './user-traction-cars.component.html',
  styleUrls: ['./user-traction-cars.component.scss']
})
export class UserTractionCarsComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public userService: UserService
  ) {}

  ngOnInit() {
    this.userService.getTransports();
  }

  removeTransport(id: number, btn: MatButton) {
    btn.disabled = true;

    this.userService.removeTransport(id)
      .pipe(finalize(() => {
        btn.disabled = false;
      }))
      .subscribe(
        () => this.userService.getTransports()
      )
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ModalAddTractionCarComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.userService.getTransports();
      }
    });
  }

}
